import { render, staticRenderFns } from "./PendingActivity.vue?vue&type=template&id=4fa5a1cf"
import script from "./PendingActivity.vue?vue&type=script&lang=js"
export * from "./PendingActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports